export class SynthKeys {
  constructor(keys: number[], durations: number[] | string[]) {
    this.keys = keys;
    this.durations = durations;
  }

  keys: number[];
  durations: number[] | string[];
}
